import React, { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import Markdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import StoryBody from './StoryBody'
import style from '../../styles/components/story/story-body'

const Story = ({ story, viewTranscript }) => {
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'On_Story_Page',
        storyCategory: story?.categories[0]?.name,
        author: story?.authors?.map((author) => author.byline)?.join(', '),
        type: story?.storyType,
        show: story?.show?.name
      }
    })
  }, [])

  if (viewTranscript) {
    return (
      <>
        <div className='article-body'>
          <Markdown children={story?.videoFile?.transcript} />
        </div>
        <style jsx global>
          {style}
        </style>
      </>
    )
  }

  return (
    <>
      <div className='article-body'>
        {story?.html?.format === 'markdown' ? (
          <Markdown children={story?.html?.body} rehypePlugins={[rehypeRaw]} />
        ) : (
          <StoryBody story={story} />
        )}
      </div>
      <style jsx global>
        {style}
      </style>
    </>
  )
}

export default Story
